// extracted by mini-css-extract-plugin
module.exports = {"blackDiamond":"style-module__blackDiamond___2dI2Q"};